// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-NYO","col":"styles_col__2ci8Z"};